export const parameterModels = {
  noteModel: {
    displayName: {
      default: 'New Note',
      displayName: 'Display Name',
      inputType: 'text',
    },
    note: {
      default: 'New Note',
      displayName: 'Note',
      inputType: 'text',
    },
    parameterType: {
      default: 'note',
      displayName: 'ParameterType',
    },
  },
  drivingParameterModel: {
    conditional: {
      default: true,
      displayName: 'Always On',
      inputType: 'boolean',
    },
    displayName: {
      default: 'New Parameter',
      displayName: 'Display Name',
      inputType: 'text',
    },
    inputType: {
      default: 'text',
      displayName: 'Input Type',
      inputType: 'select',
      values: ['select', 'text'],
    },
    isPreloaded: {
      default: true,
      displayName: 'Preload',
      inputType: 'boolean',
    },
    name: {
      default: 'newParameter',
      displayName: 'Parameter Name',
      inputType: 'text',
    },
    note: {
      default: '',
      displayName: 'Note',
      inputType: 'text',
    },
    onConditions: {
      displayName: 'Display Conditions',
      inputType: 'expression',
    },
    parameterType: {
      default: 'driving',
      displayName: 'Parameter Type',
    },
    type: {
      default: 'text',
      displayName: 'Type',
      inputType: 'select',
      values: ['numeric', 'text', 'boolean'],
    },
    unit: {
      default: '',
      displayName: 'Unit',
      inputType: 'text',
    },
    value: {
      displayName: 'Value',
      inputType: 'Text',
    },
    valueConditions: {
      displayName: 'Value Conditions',
      inputType: 'expression',
    },
    values: {
      displayName: 'Values',
      inputType: 'textList',
    },
  },
  referenceParameterModel: {
    displayName: {
      default: 'New Parameter',
      displayName: 'Display Name',
      inputType: 'text',
    },
    name: {
      default: 'newParameter',
      displayName: 'Parameter Name',
      inputType: 'text',
    },
    note: {
      default: '',
      displayName: 'Note',
      inputType: 'text',
    },
    parameterType: {
      default: 'reference',
      displayName: 'Parameter Type',
    },
    type: {
      default: 'Inventor',
      displayName: 'Type',
      inputType: 'select',
      values: ['Inventor'],
    },
    visible: {
      default: true,
      displayName: 'Visible',
      inputType: 'boolean',
    },
  },
};
